import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable({
    providedIn: 'root'
})
export class OtpService {

    constructor(
        private storageService: StorageService
    ) {
    }

    saveVerified(identifier: string, code: string) {
        this.storageService.save(`OTP:Verified:${identifier}`, code);
    }

    getCode(identifier: string): string | null {
        return this.storageService.retrieve(`OTP:Verified:${identifier}`);
    }
}